import React, { Component } from 'react';
import { Button, Table, Tabs, Drawer } from 'antd';
import { withRouter, } from 'react-router-dom';
import consts, { PREFIX_FRONT_URL } from '../../consts';
import utils from '../../common/utils';
import _ from 'lodash';
import DisplayControl from '../DisplayControl'
import { ArrowLeftOutlined, SnippetsOutlined } from '@ant-design/icons';

const { COLOR_BUY, COLOR_SELL } = consts;
const { TabPane } = Tabs;
const PERMISSION_LINK_SCREEN = '/user/list-addresses'
const arr = [
  {key: 0, title: "Số dư đồng"},
  {key: 1, title: "Giao dịch"},
  {key: 2, title: "Lệnh mở"},
  {key: 3, title: "Lịch sử lệnh"},
  {key: 4, title: "Lịch sử lệnh khớp"},
  {key: 5, title: "Lịch sử đăng nhập"},
]
  


class UserDetail extends Component {
  constructor(props) {
    super(props);
    this.state = {
      key: 0,
      coins: {},
      isLoading: false,
      visible: false,
      currentPageTrans: 1,
      currentPageOrderTrans: 1,
      currentPageOpenOrders: 1,
      currentPageOrderHistory: 1,
      currentPageHistoryLogin: 1,
      currentPageListAdress: 1,
      countUsers: 0,
      countTrans: 0,
      countOrderTrans: 0,
      countOpenOrders: 0,
      countOrderHistory: 0,
      countHistoryLogin: 0,
      countListAdress: 0,
      confirmLoading: false,
      userBalances: [],
      trans: [],
      openOrders: [],
      orderHistory: [],
      orderTransactions: [],
      userLoginHistory: [],
      userAddressList: [],
    };
    this.filter = {
      contract: '',
      trans_type: consts.TYPE_ALL,
      trans_status: consts.TYPE_ALL,
      coin: '',
      currency: '',
      trade_type: -1,
      begin: '',
      end: '',
      pos: 0,
      count: consts.DEFAULT_PAGE_SIZE,
      pubkey: '',
    };
  }

  showDrawer = () => {
    this.setState({
      visible: true
    })
  };

  onClose = () => {
    this.setState({
      visible: false
    })
  };

  getName = (symbol) => {
    const {coins} = this.props;
    
    return <div className='d-flex justify-center'>
      <div style={{width: "45px", textAlign: "left"}}>
        <div style={{
          backgroundImage: `url(${coins[symbol]?.icon_image || ''})`,
          height: '26px',
          width: '26px',
          backgroundSize: 'contain',
          marginRight: "20px",
          display: 'block',
          backgroundRepeat: 'no-repeat',
          fontWeight: 600,
          color: 'black',
        }} alt={symbol} />
      </div>
      <div style={{width: "50px", textAlign: "left", fontWeight: "bold", lineHeight: '28px'}}>{symbol}</div>
    </div>
  }

  userCols = () => [
    {
      align: "center",
      title: 'Đồng',
      dataIndex: 'coin',
      key: 'coin',
      render: this.getName
    },
    {
      align: "center",
      title: 'Tên',
      dataIndex: 'coin',
      key: 'coin',
      render: (coin) => (
        <div>
          <div>{_.get(this.props, ['coins', coin, 'coin']) === coin ? _.get(this.props, ['coins', coin, 'name']) : ''}</div>
        </div>
      ),
    },
    {
      align: "center",
      title: 'Số dư',
      dataIndex: 'balance',
      key: 'balance',
      render: (balance) => isNaN(balance) ? '' : utils.formatCurrency(balance)
    },
    {
      align: "center",
      title: 'Số dư có sẵn',
      dataIndex: 'available_balance',
      key: 'available_balance',
      render: (available_balance) => isNaN(available_balance) ?  '' : utils.formatCurrency(available_balance)
    },
  ];

  transCols = () => [
    {
      title: 'Tài khoản',
      dataIndex: 'pubkey',
      key: 'pubkey',
      render: (pubkey) => <div
        className='ellipsis'
        title={pubkey}
      >{pubkey}</div>
    },
    {
      align: "center",
      title: 'Đồng',
      dataIndex: 'currency',
      key: 'currency',
    },
    {
      align: "center",
      title: 'Thời gian',
      dataIndex: 'created_at',
      key: 'created_at',
    },
    {
      title: 'Địa chỉ gửi',
      dataIndex: 'from_address',
      key: 'from_address',
      render: (fromAddr) => <div
        className='ellipsis'
        title={fromAddr}
      >{fromAddr}</div>
    },
    {
      title: 'Địa chỉ nhận',
      dataIndex: 'to_address',
      key: 'to_address',
      render: (toAddr) => <div
        className='ellipsis'
        title={toAddr}
      >{toAddr}</div>
    },
    {
      align: "center",
      title: 'Số tiền giao dịch',
      dataIndex: 'total',
      key: 'total',
    },
    {
      align: "center",
      title: 'Phí giao dịch',
      dataIndex: 'fee',
      key: 'fee',
    },
    {
      align: "center",
      title: 'Số tiền nhận được',
      dataIndex: 'amount',
      key: 'amount',
    },
    {
      align: "center",
      title: 'Loại',
      dataIndex: 'type',
      key: 'type',
      render: (type) =>  <div style={{ color: type === 0 ? consts.COLOR_BUY : consts.COLOR_SELL}}>
        { type !== undefined ? utils.parseTransType(type) : ""}
      </div>
    },
    {
      align: "center",
      title: 'Trạng thái',
      dataIndex: 'status',
      key: 'status',
    },
  ];

  orderTransCols = () => [
    {
      title: 'Tài Khoản',
      width: 300,
      render: (tranType, orderTrans) => <div
        style={{
          overflow: 'hidden',
          whiteSpace: 'nowrap',
          width: 260,
          textOverflow: 'ellipsis',
        }}
        title={utils.isBuyOrder(tranType) ? orderTrans.buyer_pubkey : orderTrans.seller_pubkey}>
        {utils.isBuyOrder(tranType) ? orderTrans.buyer_pubkey : orderTrans.seller_pubkey}
      </div>
    },
    {
      align: "center",
      title: 'Thời gian',
      dataIndex: 'created_at',
      key: 'created_at',
      render: (createdAt) => createdAt ? utils.formatTimeFromUnix(createdAt, 'DD/MM/YYYY HH:mm') : '',
    },
    {
      align: "center",
      title: 'Loại giao dịch',
      dataIndex: 'transaction_type',
      key: 'transaction_type',
      // render: (transactionType) => utils.parseOrderType(transactionType),
      render: (tranType) => <div style={{
        color: utils.isBuyOrder(tranType) ? COLOR_BUY : COLOR_SELL,
      }}>
        {utils.parseTradeType(tranType)}
      </div>,
    },
    {
      align: "center",
      title: 'Cặp',
      dataIndex: 'pair',
      key: 'pair',
    },
    {
      align: "center",
      title: 'Giá',
      dataIndex: 'price',
      key: 'price',
      render: (price) => price !== undefined ? utils.formatCurrency(price) : ""
    },
    {
      align: "center",
      title: 'Số lượng',
      dataIndex: 'quantity',
      key: 'quantity',
    },
    {
      align: "center",
      title: 'Tổng số',
      dataIndex: 'amount',
      key: 'amount',
    },
  ];
  
  orderCols = () => [
    {
      title: 'Tài Khoản',
      width: 160,
      dataIndex: 'pubkey',
      key: 'pubkey',
      fixed: 'left',
      render: (pubkey) => <div
        style={{
          overflow: 'hidden',
          whiteSpace: 'nowrap',
          maxWidth: '252px',
          textOverflow: 'ellipsis',
        }}
        title={pubkey}>{pubkey}</div>
    },
    {
      align: "center",
      title: 'Thời gian',
      width: 180,
      dataIndex: 'created_at',
      key: 'created_at',
      fixed: 'left',
      render: (createdAt) => createdAt ? utils.formatTimeFromUnix(createdAt, 'DD/MM/YYYY HH:mm') : '',
    },
    {
      align: "center",
      title: 'Loại lệnh',
      width: 120,
      dataIndex: 'type',
      key: 'type',
      fixed: 'left',
      render: (type) => utils.parseOrderType(type)
    },
    {
      align: "center",
      title: 'Loại giao dịch',
      width: 160,
      dataIndex: 'trade_type',
      render: (tradeType) => <div
        style={{ color: utils.isBuyOrder(tradeType) ? COLOR_BUY : COLOR_SELL, }}
      >
        {utils.parseTradeType(tradeType)}
      </div>,
    },
    {
      align: "center",
      title: 'Cặp',
      width: 120,
      dataIndex: 'pairs',
      key: '2'
    },
    {
      align: "center",
      title: 'Giá',
      width: 110,
      dataIndex: 'price',
      key: '3',
      render: (price) => price !== undefined ? utils.formatCurrency(price) : ""
    },
    {
      align: "center",
      title: 'Số lượng',
      dataIndex: 'amount',
      width: 170,
      key: '4'
    },
    {
      align: "center",
      title: 'Tổng',
      dataIndex: 'total',
      key: '5'
    },
    {
      align: "center",
      title: 'Đã khớp',
      dataIndex: 'executed_quantity',
      width: 170,
      key: '6'
    },
    {
      align: "center",
      title: 'Còn lại',
      width: 100,
      dataIndex: 'quantity',
      key: '7',
      render: (quantity) => quantity !== undefined ? utils.formatCurrency(quantity) : ""
    },
    {
      align: "center",
      title: 'Trạng thái',
      width: 180,
      dataIndex: 'status',
      key: 'status',
      fixed: 'right',
      render: (status) => utils.parseOrderStatus(status),
    },
  ];

  loginHistory = () => [
    {
      title: 'Pubkey',
      dataIndex: 'pubkey',
      key: 'pubkey',
      ellipsis: true,
    },
    {
      title: 'Tác nhân',
      dataIndex: 'agent',
      key: 'agent',
      ellipsis: true,
    },
    {
      title: 'IP',
      dataIndex: 'ip',
      key: 'ip',
      width: 200,
    },
    {
      title: 'Thời gian đăng nhập',
      dataIndex: 'created_at',
      key: 'created_at',
      width: 200,
      render: (createdAt) =>  createdAt ? utils.formatTimeFromUnix(createdAt, 'DD/MM/YYYY HH:mm') : '',
    },
  ];

  listAddress = () => [
    {
      title: 'Pubkey',
      dataIndex: 'pubkey',
      key: 'pubkey',
      ellipsis: true,
      width: 500,
    },
    {
      align: "center",
      title: 'Coin',
      dataIndex: 'coin',
      key: 'coin',
    },
    {
      align: "center",
      title: 'Tên hiển thị',
      dataIndex: 'label',
      key: 'label',
    },
    {
      title: 'Địa chỉ',
      dataIndex: 'address',
      key: 'address',
      ellipsis: true,
      width: 400,
    },
    {
      align: "center",
      title: 'Thời gian nạp',
      dataIndex: 'created_at',
      key: 'created_at',
      width: 200,
      render: (createdAt) =>  createdAt ? utils.formatTimeFromUnix(createdAt, 'DD/MM/YYYY HH:mm') : '',
    },
  ];

  componentDidMount() {
    this.userBalancesAction();
  }

  onBackList = (value) => {
    this.props.history.push(`${PREFIX_FRONT_URL}/${window.c.routes.LIST_USERS}`)
  }

  setFilter = (pos = 0, count = consts.DEFAULT_PAGE_SIZE, isRefresh = false) => {
    if (isRefresh) {
      this.filter = {
        ...this.filter,
        pos: 0,
        count: consts.DEFAULT_PAGE_SIZE,
      }
    } else {
      this.filter = {
        ...this.filter,
        pos,
        count,
      }
    }
  }

  userBalancesAction = () => {
    this.props.userBalancesAction({
      pubkey: this.props.match.params.id,
    }, () => {
      this.setState({isLoading: false})
    })
  }

  fetchOrderTrans = (pos, count) => {
    this.setFilter(pos, count)
    this.props.onFetchUserOrderTransHistoryAction({
      ...this.filter,
      pubkey: this.props.match.params.id,
    }, this.setCountOrderTrans);
  }


  fetchTrans = (pos, count) => {
    this.setFilter(pos, count)
    this.props.onFetchUserTransHistoryAction({
      ...this.filter,
      pubkey: this.props.match.params.id,
    }, this.setCountTrans);
  }
  
  fetchOrderHistory = (pos, count) => {
    this.setFilter(pos, count)
    this.props.onFetchUserOrderHistory({
      ...this.filter,
      pubkey: this.props.match.params.id,
    }, this.setCountOrder);
  }
  
  fetchOpenOrder = (pos, count) => {
    this.setFilter(pos, count)
    this.props.onFetchUserOpenOrderHistoryAction({
      ...this.filter,
      pubkey: this.props.match.params.id,
    }, this.setCountOpenOrder);
  }

  fetchLoginHistory = (pos, count) => {
    this.setFilter(pos, count)
    this.props.onFetchUserLoginHitoryAction({
      ...this.filter,
      pubkey: this.props.match.params.id,
    },this.setCountHistoryLogin )
  }

  fetchUserListAddress = () => {
    this.props.onUserListAddressAction({
      pubkey: this.props.match.params.id,
    },this.setUserListAdress )
  }

  setCountTrans = (countTrans) => this.setState({ countTrans, isLoading: false });
  setCountOrderTrans = (countOrderTrans) => this.setState({ countOrderTrans, isLoading: false });
  setCountOpenOrder = (countOpenOrders) => {this.setState({ countOpenOrders, isLoading: false })};
  setCountOrder = (countOrderHistory) => this.setState({ countOrderHistory, isLoading: false });
  setCountHistoryLogin = (countHistoryLogin) => this.setState({ countHistoryLogin, isLoading: false });
  setUserListAdress = (countListAdress) => this.setState({ countListAdress, isLoading: false });
  
  callback(key) {
    // console.log(key);
  }

  UNSAFE_componentWillReceiveProps(nextProps){
    if(this.props !== nextProps){
      let userBalances = utils.fillTable(nextProps.userBalances)
      let trans = utils.fillTable(nextProps.trans)
      let openOrders = utils.fillTable(nextProps.order.openOrders)
      let orderHistory = utils.fillTable(nextProps.order.orderHistory)
      let orderTransactions = utils.fillTable(nextProps.orderTrans.orderTransactions)
      let userLoginHistory = utils.fillTable(nextProps.userLoginHistory)
      let userAddressList = utils.fillTable(nextProps.userAddressList)

      this.setState({
          userBalances,
          trans,
          openOrders,
          orderHistory,
          orderTransactions,
          userLoginHistory,
          userAddressList,
      })
    }
  }

  columns = () => {
    switch(this.state.key){
      case 0:
        return this.userCols();
      case 1:
        return this.transCols();
      case 2:
        return this.orderCols();
      case 3:
        return this.orderCols();
      case 4:
        return this.orderTransCols();
      case 5:
        return this.loginHistory();
      case 6:
        return this.listAddress();
      default:
        return '';
    }
  }

  data = () => {
    switch(this.state.key){
      case 0:
        return this.state.userBalances || [];
      case 1:
        return this.state.trans || []
      case 2:
        return this.state.openOrders || []
      case 3:
        return this.state.orderHistory || []
      case 4:
        return this.state.orderTransactions || []
      case 5:
        return this.state.userLoginHistory || []
      case 6:
        return this.state.userAddressList || []
      default:
        return '';
    }
  }

  currentPage = () => {
    switch(this.state.key){
      case 0:
        return ;
      case 1:
        return this.state.currentPageTrans
      case 2:
        return this.state.currentPageOpenOrders
      case 3:
        return this.state.currentPageOrderHistory
      case 4:
        return this.state.currentPageOrderTrans
      case 5:
        return this.state.currentPageHistoryLogin
      case 6:
        return ;
      default:
        return ;
    }
  }

  totalCount = () => {
    switch(this.state.key){
      case 0:
        return ;
      case 1:
        return this.state.countTrans
      case 2:
        return this.state.countOpenOrders
      case 3:
        return this.state.countOrderHistory
      case 4:
        return this.state.countOrderTrans
      case 5:
        return this.state.countHistoryLogin
      case 6:
        return 1
      default:
        return ;
    }
  }

  onChange = (pos, count) => {
    switch(this.state.key){
      case 0:
        return ;
      case 1:
        this.setState({ currentPageTrans: pos, isLoading: true });
        return this.fetchTrans((pos - 1) * count, count)
      case 2:
        this.setState({ currentPageOpenOrders: pos, isLoading: true });
        return this.fetchOpenOrder((pos - 1) * count, count)
      case 3:
        this.setState({ currentPageOrderHistory: pos, isLoading: true });
        return this.fetchOrderHistory((pos - 1) * count, count)
      case 4:
        this.setState({ currentPageOrderTrans: pos, isLoading: true });
        return this.fetchOrderTrans((pos - 1) * count, count)
      case 5:
        this.setState({ currentPageHistoryLogin: pos, isLoading: true });
        return this.fetchLoginHistory((pos - 1) * count, count)
      case 6:
        return ;
      default:
        return ;
    }
  }

  onChangeMenu = (key) => {
    const {
      currentPageTrans, 
      currentPageOpenOrders, 
      currentPageOrderHistory, 
      currentPageOrderTrans, 
      currentPageHistoryLogin
    } = this.state
    this.setState({key, isLoading: true})
    switch(key){
      case 0:
        return this.setState({isLoading: false});
      case 1:
        return this.fetchTrans((currentPageTrans - 1) * consts.DEFAULT_PAGE_SIZE,  consts.DEFAULT_PAGE_SIZE)
      case 2:
        return this.fetchOpenOrder((currentPageOpenOrders - 1) * consts.DEFAULT_PAGE_SIZE,  consts.DEFAULT_PAGE_SIZE)
      case 3:
        return this.fetchOrderHistory((currentPageOrderHistory - 1) * consts.DEFAULT_PAGE_SIZE,  consts.DEFAULT_PAGE_SIZE)
      case 4:
        return this.fetchOrderTrans((currentPageOrderTrans - 1) * consts.DEFAULT_PAGE_SIZE,  consts.DEFAULT_PAGE_SIZE)
      case 5:
        return this.fetchLoginHistory((currentPageHistoryLogin - 1) * consts.DEFAULT_PAGE_SIZE,  consts.DEFAULT_PAGE_SIZE)
      case 6:
        return this.fetchUserListAddress({ pubkey: this.props.match.params.id})
      default:
        return this.setState({isLoading: false});
    }
  }


  render() {
    const { visible, key } = this.state;
  
    return (
      <div className="withdrawalHistory">
          <div className='mt-small'>
            <div className="mb-small d-flex space-between align-items">
              <div className='fz-24'>{_.get(_.find(arr, {key}), 'title')}</div>
              <Button onClick={this.showDrawer}  type="primary" >
                <div className='mb-small d-flex align-items'>
                  <SnippetsOutlined  className='fz-16 mr-small' /> <span className='fz-16'>Lựa chọn</span>
                </div>
                </Button>
            </div>
          <Table 
                  columns={this.columns()}
                  rowClassName="height-row-table"
                    dataSource={this.data() || []}
                    pagination={{
                      current: this.currentPage(),
                      onChange: (page, pageSize) => this.onChange(page, pageSize),
                      defaultPageSize: consts.DEFAULT_PAGE_SIZE,
                      total: this.totalCount(),
                     hideOnSinglePage: true,
                    }} bordered
                    loading={this.state.isLoading}
                />
          </div>
          <Drawer
            // title="Chi tiết"
            width={300}
            placement="right"
            closable={false}
            onClose={this.onClose}
            visible={visible}
          >
             <div className='d-flex direct-column'>
                <Button shape="round" className='mb-small d-flex align-items' onClick={this.onBackList}>
                  <ArrowLeftOutlined className='fz-18' /><span className='fz-18'>Danh sách người dùng</span>
                </Button>
                <div>
                  {_.map(arr, (value, index) => (
                    <Button className="d-block fz-16" onClick={() => this.onChangeMenu(index)} type={key === value.key ? "link" : "text"}>{value.title}</Button>
                  ))}
              <DisplayControl permission_link_screen={PERMISSION_LINK_SCREEN} action="GET">
                <Button className="d-block fz-16" onClick={() => this.onChangeMenu(6)} type={key === 6 ? "link" : "text"}>Địa chỉ nạp tiền</Button>
              </DisplayControl>
                </div>
             </div>
        </Drawer>
      </div>
    );
  }
}

export default withRouter(UserDetail);
